import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'
import aioRoutes from './aio'
import weeksStudyRoutes from './weeksStudy'
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '好未来图书'
    }
  },
  {
    path: '/question-result',
    name: 'QuestionResult',
    component: () => import('../views/QuestionResult.vue'),
    meta: {
      title: '题目解析'
    }
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('../views/test.vue'),
    meta: {
      title: '题目解析'
    }
  },
  {
    path: '/test-paper',
    name: 'testPaper',
    component: () => import('../views/testPaper.vue'),
    meta: {
      title: '半屏资源测试'
    }
  },
  {
    path: '/report',
    name: 'report',
    component: () => import('../views/report.vue'),
    meta: {
      title: '半屏资源测试'
    }
  },
  {
    path: '/report',
    name: 'report',
    component: () => import('../views/report.vue'),
    meta: {
      title: '学习报告'
    }
  },
  {
    path: '/scan-result',
    name: 'ScanResult',
    component: () => import('../views/ScanResult.vue'),
    meta: {
      title: '扫码结果'
    }
  },
  {
    path: '/collection-list',
    name: 'CollectionList',
    component: () => import('../views/QuestionCollection/Index.vue'),
    meta: {
      title: '智能推荐收藏'
    }
  },
  {
    path: '/collection-detail',
    name: 'CollectionDetail',
    component: () => import('../views/QuestionCollection/Details.vue'),
    meta: {
      title: '题目'
    }
  },
  {
    path: '/recruit',
    name: 'Recruit',
    component: () => import('../views/Activity/Recruit.vue'),
    meta: {
      title: '拍照批改体验官招募啦'
    }
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('../views/AndroidDownload.vue'),
    meta: {
      title: '安卓下载'
    }
  },
  {
    path: '/wrong-question-list',
    name: 'WrongQuestionList',
    component: () => import('../views/WrongQuestion/Index.vue'),
    meta: {
      title: '错题本'
    }
  },
  {
    path: '/wrong-question-detail',
    name: 'WrongQuestionDetail',
    component: () => import('../views/WrongQuestion/Details.vue'),
    meta: {
      title: '错题本'
    }
  },
  {
    path: '/recommend-list',
    name: 'RecommendList',
    component: () => import('../views/RecommendList.vue'),
    meta: {
      title: '推荐题目列表'
    }
  },
  {
    path: '/info-collection',
    name: 'InfoCollection',
    component: () => import('../views/InfoCollection/index.vue'),
    meta: {
      title: '个人信息收集清单'
    }
  },
  {
    path: '/info-collection-list',
    name: 'InfoCollectionList',
    component: () => import('../views/InfoCollection/List.vue'),
    meta: {
      title: ''
    }
  },
  {
    path: '/info-collection-detail',
    name: 'InfoCollectionDetail',
    component: () => import('../views/InfoCollection/Details.vue'),
    meta: {
      title: ''
    }
  },
  {
    path: '/destroy-account',
    name: 'DestroyAccount',
    component: () => import('../views/DestroyAccount/Index.vue'),
    meta: {
      title: '注销账号'
    }
  },
  {
    path: '/destroy-account-reason',
    name: 'DestroyAccountReason',
    component: () => import('../views/DestroyAccount/Reason.vue'),
    meta: {
      title: '注销账号'
    }
  },
  {
    path: '/destroy-account-success',
    name: 'DestroyAccountSuccess',
    component: () => import('../views/DestroyAccount/Success.vue'),
    meta: {
      title: '注销账号'
    }
  },
  {
    path: '/destroy-account-fail',
    name: 'DestroyAccountFail',
    component: () => import('../views/DestroyAccount/Fail.vue'),
    meta: {
      title: '注销账号'
    }
  },
  {
    path: '/compare-answer',
    name: 'CompareAnswer',
    component: () => import('../views/CompareAnswer.vue'),
    meta: {
      title: '自己对答案'
    }
  },
  {
    path: '/photo-correct-result',
    name: 'PhotoCorrectResult',
    component: () => import('../views/Book/PhotoCorrectResult.vue')
  },
  {
    path: '/support-book-list',
    name: 'SupportBookList',
    component: () => import('../views/Book/SupportBookList.vue'),
    meta: {
      title: '支持图书',
      showActionBar: false
    }
  },
  {
    path: '/home-download',
    name: 'HomeDownload',
    component: () => import('../views/Download.vue'),
    meta: {
      title: '好未来图书下载'
    }
  },
  {
    path: '/workWall',
    name: 'WorkWall',
    component: () => import('../views/WordCard/WorkWall.vue'),
    meta: {
      title: '作品墙',
      showActionBar: false
    }
  },
  {
    path: '/collectCard',
    name: 'CollectCard',
    component: () => import('../views/WordCard/CollectCard.vue'),
    meta: {
      title: '识字卡',
      showActionBar: false
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes: [...routes, ...aioRoutes, ...weeksStudyRoutes],
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  }
})

export default router
